module.exports = __webpack_public_path__ + "img/signs1_1.d5298b67.jpg";